var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"citrixlogin"}},[_c('a',{attrs:{"href":"https://citrix.affinitylogon.com/"}},[_vm._v("Affinity Desktop User Login")])])
}]

export { render, staticRenderFns }